import React, { useEffect } from 'react';
import { addToCart as AddToCartMutation } from '@jetshop/core/data/mutations/cartMutations.gql';
import { Mutation } from 'react-apollo';
import useCartAdder from './useCartAdder';
import CartQuery from '@jetshop/core/data/queries/CartQuery.gql';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import logWarningInDev from '../../helpers/logWarningInDev';
import useWarningInDev from '../../hooks/useWarningInDev';
function useValidateCartProps({ cartQuery, cartMutation, onAddToCart }) {
    useWarningInDev(!!onAddToCart, '`onAddToCart` is deprecated in favour of `onAddToCartInit`');
    useEffect(() => {
        if (cartQuery && !cartMutation) {
            logWarningInDev(true, `You provided 'cartQuery' without providing 'cartMutation'. This will throw an error in future versions.`);
            return;
        }
        throwErrorInDev(cartMutation && !cartQuery, `You provided 'cartMutation' without providing 'cartQuery'`);
        if (!cartMutation || !cartQuery) {
            return;
        }
        // Validate that the same `Cart`-fragment is used on both mutation and query
        const findCartFragment = ({ kind, name }) => kind === 'FragmentDefinition' && name.value === 'Cart';
        const addToCartCartFragment = cartMutation.addToCart.definitions.find(findCartFragment);
        const cartQueryCartFragment = cartQuery.CartQuery.definitions.find(findCartFragment);
        throwErrorInDev(addToCartCartFragment !== cartQueryCartFragment, `Cart fragment in "addToCart" and "cartQuery" does not match`);
    }, [cartMutation, cartQuery]);
}
// At the moment this is necessary because there is no `useMutation` hook. It's
// the only way we can get `mutate` and `client` in to `useAddToCart`
const AddToCartContainer = function AddToCartContainer(props) {
    logWarningInDev(!props.cartQuery, `Using AddToCartContainer without cartQuery is deprecated and will not work in the next major release.`);
    logWarningInDev(!props.cartMutation, `Using AddToCartContainer without cartMutation is deprecated and will not work in the next major release.`);
    useValidateCartProps(props);
    const { cartQuery = CartQuery, cartMutation = AddToCartMutation } = props;
    return (React.createElement(Mutation, { mutation: cartMutation }, (mutate, { client }) => {
        return (React.createElement(AddToCart, { mutate: mutate, client: client, cartQuery: cartQuery, onAddToCart: props.onAddToCart, onAddToCartInit: props.onAddToCartInit, onAddToCartError: props.onAddToCartError, onAddToCartSuccess: props.onAddToCartSuccess }, props.children));
    }));
};
const AddToCart = function AddToCart(props) {
    const { mutate, client, cartQuery, onAddToCart, onAddToCartInit, onAddToCartError, onAddToCartSuccess } = props;
    const { addToCart, missingOption, hasMissingOption } = useCartAdder({
        mutate,
        client,
        cartQuery,
        onAddToCart,
        onAddToCartInit,
        onAddToCartError,
        onAddToCartSuccess
    });
    return props.children(addToCart, missingOption, hasMissingOption);
};
export default AddToCartContainer;
//# sourceMappingURL=AddToCart.js.map